/* eslint-disable react/prop-types */
const TBody = ({ children, className }) => {
    return (
        <tbody className={className}>{children}</tbody>
    )
};

export default TBody;